module.exports = __webpack_public_path__ + "img/nurse_dashboard.c986bca6.svg";